import React, { ChangeEvent, useEffect } from 'react';
import { TextInput, TextInputProps } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';

interface Props extends TextInputProps {
    debounce?: number;
}
function DebouncedInput({
    value: initialValue,
    onChange,
    debounce = 300,
    ...props
}: Props) {
    const [value, setValue] = useDebouncedState(initialValue, debounce, {
        leading: true,
    });

    const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        if (onChange) {
            onChange({ target: { value } } as ChangeEvent<HTMLInputElement>);
        }
    }, [value]);

    return (
        <TextInput {...props} defaultValue={value} onChange={onChangeValue} />
    );
}

export default DebouncedInput;
